"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EScreenUnit = void 0;
/**
 * @public
 * Supported methods of describing screen space dimensions.
 */
var EScreenUnit;
(function (EScreenUnit) {
    /**
     * Clip space.
     */
    EScreenUnit[EScreenUnit["Clip"] = 1] = "Clip";
    /**
     * Screen space.
     */
    EScreenUnit[EScreenUnit["ActualPixel"] = 2] = "ActualPixel";
    /**
     * Css screen space (equal to `ActualPixel` / `DPR`).
     */
    EScreenUnit[EScreenUnit["CssPixel"] = 3] = "CssPixel";
})(EScreenUnit = exports.EScreenUnit || (exports.EScreenUnit = {}));
//# sourceMappingURL=e-screen-unit.js.map